function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export default memoize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/node_modules/@emotion/memoize/dist/memoize.esm.js
// module id = 1934
// module chunks = 1